var _path, _path2, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _g11, _g12, _g13, _g14, _g15, _g16, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgReactionChefsKiss(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 79,
    height: 79,
    viewBox: "0 0 79 79",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M60.3818 45.0708C60.3818 56.8923 50.7986 66.4755 38.977 66.4755C27.1555 66.4755 17.5723 56.8923 17.5723 45.0708C17.5723 33.2493 27.1555 23.666 38.977 23.666C50.7986 23.666 60.3818 33.2493 60.3818 45.0708Z",
    fill: "url(#paint0_radial_3003_69611)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3003_69611",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 17,
    y: 23,
    width: 44,
    height: 44
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M60.3818 45.0708C60.3818 56.8923 50.7986 66.4755 38.977 66.4755C27.1555 66.4755 17.5723 56.8923 17.5723 45.0708C17.5723 33.2493 27.1555 23.666 38.977 23.666C50.7986 23.666 60.3818 33.2493 60.3818 45.0708Z",
    fill: "url(#paint1_radial_3003_69611)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3003_69611)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_3003_69611)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 27.618,
    cy: 50.0898,
    rx: 8.1993,
    ry: 5.92171,
    transform: "rotate(-90 27.618 50.0898)",
    fill: "#F85A17"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_3003_69611)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 50.8489,
    cy: 50.0898,
    rx: 8.1993,
    ry: 6.37723,
    transform: "rotate(-90 50.8489 50.0898)",
    fill: "#F85A17"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_3003_69611)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M62.4158 40.0168C60.4254 39.4835 58.7457 40.8708 58.3696 42.2773C57.5565 45.3184 60.3106 49.0812 62.3068 51.5417C65.264 50.4084 69.5275 48.5257 70.3405 45.4849C70.7166 44.0786 69.9537 42.0366 67.9634 41.5033C66.8518 41.2055 65.6687 41.824 64.7345 42.4625C64.2437 41.4422 63.5275 40.3147 62.4159 40.0169L62.4158 40.0168Z",
    fill: "#F85A17"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.75,
    filter: "url(#filter3_i_3003_69611)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.2754 38.6257C45.3375 39.0571 45.7377 38.6342 47.8065 38.6417C49.8754 38.6491 52.3286 40.1998 52.4882 39.8218C52.7149 39.2846 49.6559 37.5289 47.647 37.5318C45.638 37.5348 45.2134 38.1943 45.2754 38.6257Z",
    fill: "#262626"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.25,
    filter: "url(#filter4_f_3003_69611)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.2754 38.6257C45.3375 39.0571 45.7377 38.6342 47.8065 38.6417C49.8754 38.6491 52.3286 40.1998 52.4882 39.8218C52.7149 39.2846 49.6559 37.5289 47.647 37.5318C45.638 37.5348 45.2134 38.1943 45.2754 38.6257Z",
    fill: "url(#paint2_radial_3003_69611)"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.75,
    filter: "url(#filter5_i_3003_69611)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.0184 39.9855C34.9766 40.5781 34.3918 40.0427 31.5844 40.257C28.7769 40.4713 25.5994 42.8216 25.3457 42.3234C24.9851 41.6155 28.9648 38.9269 31.6919 38.7326C34.4191 38.5383 35.0602 39.3929 35.0184 39.9855Z",
    fill: "#262626"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.25,
    filter: "url(#filter6_f_3003_69611)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.0184 39.9855C34.9766 40.5781 34.3918 40.0427 31.5844 40.257C28.7769 40.4713 25.5994 42.8216 25.3457 42.3234C24.9851 41.6155 28.9648 38.9269 31.6919 38.7326C34.4191 38.5383 35.0602 39.3929 35.0184 39.9855Z",
    fill: "url(#paint3_radial_3003_69611)"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.75,
    filter: "url(#filter7_i_3003_69611)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.67 45.5164C35.4336 45.3561 36.8796 44.1554 37.6225 43.0009C38.0354 42.3591 37.3661 41.9193 36.6825 42.2584C35.7907 42.7007 34.609 43.1719 33.4664 43.2757C32.3238 43.3796 31.0765 43.1291 30.1196 42.8548C29.386 42.6446 28.807 43.1978 29.3289 43.7546C30.2677 44.7563 31.9065 45.6766 33.67 45.5164Z",
    fill: "#262626"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter8_f_3003_69611)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.67 45.5164C35.4336 45.3561 36.8796 44.1554 37.6225 43.0009C38.0354 42.3591 37.3661 41.9193 36.6825 42.2584C35.7907 42.7007 34.609 43.1719 33.4664 43.2757C32.3238 43.3796 31.0765 43.1291 30.1196 42.8548C29.386 42.6446 28.807 43.1978 29.3289 43.7546C30.2677 44.7563 31.9065 45.6766 33.67 45.5164Z",
    fill: "url(#paint4_radial_3003_69611)"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.75,
    filter: "url(#filter9_i_3003_69611)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.2911 44.1668C49.0547 44.0065 50.5007 42.8058 51.2436 41.6512C51.6565 41.0095 50.9872 40.5697 50.3035 40.9088C49.4118 41.3511 48.2301 41.8223 47.0875 41.9261C45.9449 42.0299 44.6976 41.7795 43.7407 41.5052C43.0071 41.295 42.4281 41.8482 42.9499 42.405C43.8888 43.4067 45.5276 44.327 47.2911 44.1668Z",
    fill: "#262626"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter10_f_3003_69611)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.2911 44.1668C49.0547 44.0065 50.5007 42.8058 51.2436 41.6512C51.6565 41.0095 50.9872 40.5697 50.3035 40.9088C49.4118 41.3511 48.2301 41.8223 47.0875 41.9261C45.9449 42.0299 44.6976 41.7795 43.7407 41.5052C43.0071 41.295 42.4281 41.8482 42.9499 42.405C43.8888 43.4067 45.5276 44.327 47.2911 44.1668Z",
    fill: "url(#paint5_radial_3003_69611)"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M42.1528 53.7292C44.6686 53.7292 46.708 53.1174 46.708 52.3626C46.708 51.6079 44.6686 50.9961 42.1528 50.9961",
    stroke: "#262626"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M42.1528 56.4616C44.6686 56.4616 46.708 55.8498 46.708 55.0951C46.708 54.3403 44.6686 53.7285 42.1528 53.7285",
    stroke: "#262626"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M47.3293 57.9297V58.7238C47.3293 59.1923 47.4331 59.9479 47.6392 60.3721C47.9499 61.0119 48.4511 61.7038 49.0637 62.085C49.6223 62.4326 50.1669 62.525 50.8196 62.4508C51.3708 62.3882 51.8281 62.1238 52.3087 61.8698C52.7729 61.6246 53.2171 61.2485 53.4406 60.7767C53.7145 60.1985 53.5788 59.3421 53.4492 58.7324C53.4036 58.5174 53.3623 58.3162 53.2943 58.1083C53.2064 57.8398 53.2344 57.4782 53.0533 57.2519C52.8509 56.9989 52.4872 56.7339 52.2184 56.5547L52.2178 56.5542C51.9457 56.3729 51.6671 56.1872 51.3361 56.1372C50.9001 56.0714 50.4701 56.1828 50.0407 56.2061C49.3206 56.245 48.1708 56.3007 48.1427 55.2592C48.1351 54.9783 48.113 54.6648 48.3062 54.4329C48.3823 54.3417 48.4234 54.2113 48.5171 54.1359C48.667 54.0153 48.86 53.9597 49.0336 53.882C49.1184 53.8441 49.2074 53.858 49.2918 53.8261C49.426 53.7754 49.5487 53.7072 49.6877 53.6668C49.914 53.6011 50.1389 53.6109 50.372 53.6109H51.2328H51.8224C51.8698 53.6109 52.0059 53.6359 52.0462 53.6023C52.2251 53.4532 52.2663 53.1681 52.412 52.9911C52.5957 52.7682 52.8313 52.5686 53.0705 52.4101C53.6497 52.0263 54.2378 51.9453 54.9082 51.9453C55.211 51.9453 55.5288 51.9874 55.8292 52.0228C56.3946 52.0893 56.886 52.2785 57.4259 52.479C57.9853 52.6867 58.4896 53.0034 59.0355 53.2407C59.5515 53.4651 60.0384 53.8372 60.4988 54.1531C60.7141 54.3009 60.9242 54.4687 61.1487 54.6007C61.4821 54.7968 61.955 54.9512 62.2031 55.2549C62.7786 55.9592 63.4635 56.5805 63.4813 57.5617C63.4889 57.9758 63.4653 58.378 63.434 58.7883C63.3959 59.2869 63.2431 59.9181 63.49 60.3893C63.7266 60.8411 63.8463 61.3502 64.1097 61.7924C64.2767 62.0727 64.411 62.3715 64.411 62.7048C64.411 62.9112 64.4239 63.1177 64.3808 63.3202C64.3304 63.5575 64.2026 63.7471 64.1226 63.9701C64.0268 64.2374 63.8326 64.4609 63.7138 64.7189C63.6154 64.9325 63.4744 65.123 63.3651 65.3301C63.2015 65.6401 62.8264 65.8837 62.5711 66.122C62.1644 66.5015 61.6509 66.7515 61.1874 67.0537C60.7345 67.3491 60.2 67.5429 59.7736 67.8779C59.6705 67.9589 59.5692 67.9897 59.4509 68.0414C59.1978 68.1522 58.9562 68.3296 58.7149 68.4654C58.2229 68.7421 57.661 68.7931 57.1268 68.9345C56.1294 69.1985 55.1563 69.7242 54.112 69.7242C53.8453 69.7242 53.5966 69.6647 53.3352 69.6446C53.1806 69.6327 53.0553 69.5401 52.9048 69.5112C52.6268 69.4577 52.3592 69.3919 52.0914 69.2981C51.7438 69.1765 51.4336 69.0909 51.1424 68.8527C50.8458 68.61 50.5586 68.3779 50.2774 68.1168C50.0541 67.9095 49.8703 67.6559 49.6533 67.4389C49.5444 67.33 49.4175 67.2507 49.3219 67.129C49.2291 67.0109 49.0729 66.9942 48.9755 66.8751C48.7985 66.6588 48.5209 66.5002 48.317 66.2963L47.8909 65.8702C47.5961 65.5753 47.3321 65.2339 47.0388 64.9406C46.9477 64.8495 46.8986 64.6696 46.843 64.5532C46.7542 64.3677 46.5297 64.1867 46.4814 63.9937C46.4376 63.8186 46.2883 63.6075 46.1866 63.4493C45.8519 62.9286 45.544 62.3645 45.3754 61.7622C45.2846 61.4379 45.2126 61.0963 45.0999 60.7745C44.9821 60.4378 44.8494 60.0472 44.8137 59.69C44.7636 59.1892 44.8219 58.6664 44.8912 58.1815C44.9161 58.0069 44.9905 57.778 45.0633 57.6177C45.1008 57.5353 45.0896 57.4341 45.1214 57.3466C45.1656 57.2251 45.2166 57.1766 45.2936 57.0776C45.5462 56.7528 46.0776 56.864 46.419 56.9398C46.6607 56.9935 47.1913 57.2796 47.2497 57.5424C47.2806 57.6815 47.3293 57.7717 47.3293 57.9297Z",
    fill: "url(#paint6_radial_3003_69611)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M61.1298 62.549C61.7423 61.8495 59.9938 59.3165 57.2244 56.8912C54.455 54.466 51.7134 53.067 51.1009 53.7665",
    stroke: "#262626"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M63.5575 59.8057C64.5476 58.0388 62.7469 55.1476 59.5355 53.3481C56.3241 51.5486 52.9181 51.5222 51.928 53.2892",
    stroke: "#262626"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M47.3808 58.4873C47.6859 57.7905 47.3684 56.9785 46.6717 56.6734C45.975 56.3684 45.1629 56.6859 44.8578 57.3826",
    stroke: "#262626"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M48.6702 53.7491C47.9494 53.9919 47.5619 54.773 47.8046 55.4937C48.0474 56.2145 48.8285 56.602 49.5492 56.3593",
    stroke: "#262626"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_3003_69611",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 44,
    y: 53,
    width: 22,
    height: 18
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.1662 55.3088C61.4399 57.8955 63.2745 60.0626 63.8175 61.722C64.3167 63.2479 63.7796 64.5615 62.524 65.753C61.2399 66.9714 59.3098 67.9341 57.4318 68.5724C56.5032 68.8881 55.6134 69.1156 54.8605 69.2535C54.0877 69.3952 53.5239 69.4303 53.2225 69.4018C52.6397 69.3467 51.8041 68.9484 50.8135 68.1579C49.8519 67.3905 48.8551 66.3428 47.9606 65.1821C47.0667 64.0221 46.2978 62.779 45.7769 61.6356C45.2418 60.4611 45.0247 59.5138 45.0827 58.9005C45.3622 55.944 47.9855 53.7737 50.9421 54.0532C51.2176 54.0792 51.4789 54.1036 51.7274 54.1267C54.735 54.4069 55.847 54.5105 57.1662 55.3088ZM57.684 54.4533C74.9939 64.93 56.6348 70.7288 53.1284 70.3974C49.6219 70.0659 43.7557 62.3128 44.0871 58.8064C44.4186 55.3 47.5298 52.7262 51.0362 53.0576C51.3455 53.0869 51.6389 53.1139 51.9181 53.1397C54.8035 53.4058 56.16 53.531 57.684 54.4533ZM53.0688 59.6553C52.9314 61.1091 51.6414 62.1763 50.1876 62.0388C48.7337 61.9014 47.6666 60.6114 47.804 59.1576C47.9414 57.7038 49.2314 56.6366 50.6852 56.774C52.1391 56.9115 53.2062 58.2014 53.0688 59.6553ZM54.0643 59.7494C53.875 61.753 52.0971 63.2238 50.0935 63.0344C48.0898 62.845 46.619 61.0672 46.8084 59.0635C46.9978 57.0598 48.7757 55.5891 50.7793 55.7785C52.783 55.9679 54.2537 57.7457 54.0643 59.7494Z",
    fill: "#262626"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_3003_69611)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.0223 56.7963L48.1684 59.1924L50.1539 57.5499L48.0579 55.5216L48.3151 52.8006L50.2148 52.0651L69.0702 55.5216L64.9706 67.2089L50.1539 77.6858L43.5297 64.702L43.8049 56.9498L47.0223 56.7963Z",
    fill: "#262626"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter11_df_3003_69611)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.1451 26.5185C16.1451 26.5185 13.7485 26.2521 12.515 25.2682C11.4246 24.3984 10.9439 23.603 10.2861 22.2046C10.193 22.0067 10.1007 21.825 10.0127 21.6517C9.65385 20.9452 9.36636 20.3792 9.38677 19.4278C9.41738 18.0004 10.1362 17.2616 10.9754 16.3992C11.1644 16.2049 11.3596 16.0044 11.5543 15.7883C13.1805 13.9838 14.7211 13.725 16.6056 13.4084C17.1352 13.3194 17.692 13.2258 18.2855 13.0922C19.4876 12.8214 20.294 12.753 21.3205 12.6661C21.6281 12.64 21.9554 12.6123 22.319 12.5769C23.0638 12.5045 23.6656 12.487 24.2503 12.4699C24.9902 12.4484 25.7028 12.4276 26.6434 12.2975C27.711 12.1498 28.4181 11.9886 29.3072 11.7859C29.5905 11.7214 29.8922 11.6526 30.2298 11.5787C31.0415 11.4011 31.699 11.2154 32.3326 11.0365C33.2081 10.7892 34.038 10.5548 35.1657 10.3727C38.5443 9.82697 40.4841 9.85111 43.8557 10.2043C47.23 10.5578 49.2575 11.224 52.2124 12.1949C52.6298 12.3321 53.0657 12.4753 53.5265 12.6246C54.0808 12.8041 54.5881 12.9613 55.0663 13.1094C56.9386 13.6895 58.3646 14.1312 60.4164 15.2383C61.1137 15.6146 61.8727 15.831 62.6004 16.0386C64.262 16.5124 65.7601 16.9397 65.9879 19.1169C66.2818 21.9265 63.9913 22.8376 61.6898 23.7531C61.086 23.9933 60.4814 24.2337 59.9225 24.5089C58.9048 25.01 58.3151 25.2877 57.2406 25.4847C56.514 25.6179 55.9353 25.5935 55.3657 25.5167L55.5272 31.2525C55.5272 31.2525 45.0268 30.5509 38.2571 30.7415C31.4874 30.9322 20.8574 32.2288 20.8574 32.2288L20.7126 27.0869C18.1113 26.8823 16.1451 26.5185 16.1451 26.5185Z",
    fill: "url(#paint7_radial_3003_69611)"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter12_f_3003_69611)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 24.036,
    cy: 25.558,
    rx: 2,
    ry: 4.5,
    transform: "rotate(-46.3187 24.036 25.558)",
    fill: "#F7CFDA"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter13_f_3003_69611)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 54.4898,
    cy: 24.8778,
    rx: 2,
    ry: 4.5,
    transform: "rotate(32.1765 54.4898 24.8778)",
    fill: "#F7CFDA"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter14_f_3003_69611)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 34.3999,
    cy: 25.5032,
    rx: 3,
    ry: 4.5,
    transform: "rotate(-10.7926 34.3999 25.5032)",
    fill: "#F7CFDA"
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter15_f_3003_69611)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 44.4007,
    cy: 24.005,
    rx: 3,
    ry: 6,
    transform: "rotate(7.41553 44.4007 24.005)",
    fill: "#F7CFDA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_3003_69611",
    x: 7.69629,
    y: 27.8906,
    width: 39.8438,
    height: 44.3984,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7,
    result: "effect1_foregroundBlur_3003_69611"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_3003_69611",
    x: 30.4717,
    y: 27.8906,
    width: 40.7549,
    height: 44.3984,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7,
    result: "effect1_foregroundBlur_3003_69611"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_3003_69611",
    x: 54.2236,
    y: 36.9004,
    width: 20.21,
    height: 19.6406,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.970833 0 0 0 0 0.353545 0 0 0 0 0.0889931 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3003_69611"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3003_69611",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_i_3003_69611",
    x: 45.2695,
    y: 37.5312,
    width: 7.23047,
    height: 3.34961,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_3003_69611"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_f_3003_69611",
    x: 44.2695,
    y: 36.5312,
    width: 9.23047,
    height: 4.34961,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    result: "effect1_foregroundBlur_3003_69611"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_i_3003_69611",
    x: 25.3232,
    y: 38.7051,
    width: 9.69727,
    height: 4.6875,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_3003_69611"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_f_3003_69611",
    x: 24.3232,
    y: 37.7051,
    width: 11.6973,
    height: 5.6875,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    result: "effect1_foregroundBlur_3003_69611"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_i_3003_69611",
    x: 29.1279,
    y: 42.1406,
    width: 8.62109,
    height: 3.39453,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_3003_69611"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter8_f_3003_69611",
    x: 22.1279,
    y: 35.1406,
    width: 22.6211,
    height: 17.3945,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.5,
    result: "effect1_foregroundBlur_3003_69611"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter9_i_3003_69611",
    x: 42.749,
    y: 40.791,
    width: 8.62109,
    height: 3.39453,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_3003_69611"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter10_f_3003_69611",
    x: 35.749,
    y: 33.791,
    width: 22.6211,
    height: 17.3945,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.5,
    result: "effect1_foregroundBlur_3003_69611"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter11_df_3003_69611",
    x: 6.38574,
    y: 6.94922,
    width: 62.6279,
    height: 28.2793,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.976319 0 0 0 0 0.765347 0 0 0 0 0.823365 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3003_69611"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3003_69611",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    result: "effect2_foregroundBlur_3003_69611"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter12_f_3003_69611",
    x: 14.5,
    y: 16.1289,
    width: 19.0723,
    height: 18.8574,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "effect1_foregroundBlur_3003_69611"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter13_f_3003_69611",
    x: 45.5557,
    y: 14.9219,
    width: 17.8682,
    height: 19.9121,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "effect1_foregroundBlur_3003_69611"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter14_f_3003_69611",
    x: 25.334,
    y: 15.0469,
    width: 18.1318,
    height: 20.9121,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "effect1_foregroundBlur_3003_69611"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter15_f_3003_69611",
    x: 35.3262,
    y: 12.043,
    width: 18.1494,
    height: 23.9238,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "effect1_foregroundBlur_3003_69611"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_3003_69611",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(38.977 45.0708) rotate(90) scale(21.4048)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.755208,
    stopColor: "#CCA2F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7CFDA"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_3003_69611",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(38.977 45.0708) rotate(90) scale(21.4048)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.755208,
    stopColor: "#CCA2F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7CFDA"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_3003_69611",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(48.864 38.7024) rotate(87.363) scale(1.16766 3.5838)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.708333,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CCA2F8"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_3003_69611",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(30.155 40.4439) rotate(88.4992) scale(1.59151 4.87727)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.708333,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CCA2F8"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_3003_69611",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(33.5035 43.6844) rotate(-95.1928) scale(1.83947 4.84203)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.708333,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CCA2F8"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_3003_69611",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(47.1246 42.3348) rotate(-95.1928) scale(1.83947 4.84203)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.708333,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CCA2F8"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_3003_69611",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(55.9043 61.5039) rotate(98.9896) scale(8.32253 9.18338)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.588542,
    stopColor: "#CCA2F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7CFDA"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_3003_69611",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(37.9043 6.50385) rotate(90.4559) scale(25.7258 65.3868)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.708333,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7CFDA"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReactionChefsKiss);
export default __webpack_public_path__ + "static/media/reaction_chefs-kiss.faa0098c3b97b237b76d74f32216ef84.svg";
export { ForwardRef as ReactComponent };